
  import { Vue, Component } from "vue-property-decorator";

  import NotificationPopup from "@/components/notification/NotificationPopup.vue";

  import { NOTIFICATION } from "@/entities/Events";
  import { Message } from "@/data/notificationsMessages";

  @Component({
    components: {
      NotificationPopup,
    },
  })
  export default class NotificationsWrapper extends Vue {
    notifications: Message[] = [];

    created(): void {
      this.$eventBus.listen(NOTIFICATION, this.pushNotification);
    }

    beforeDestroy(): void {
      this.$eventBus.remove(NOTIFICATION);
    }

    pushNotification(notification: Message): void {
      this.notifications = [notification, ...this.notifications];
      setTimeout(() => this.notifications.pop(), notification.duration);
    }
  }
